export const SET_ROUTE = 'SET_ROUTE';

function setRoute(routes) {
    return {
        type: SET_ROUTE,
        routes,
    };
}

export default setRoute;
